{{ time[0] }} {{ time[1] | translate }}
